// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Default styles for the dygraphs charting library.
 */

.dygraph-legend {
	position: absolute;
	font-size: 14px;
	z-index: 10;
	width: 250px;  /* labelsDivWidth */
	/*
	dygraphs determines these based on the presence of chart labels.
	It might make more sense to create a wrapper div around the chart proper.
	top: 0px;
	right: 2px;
	*/
	background: white;
	line-height: normal;
	text-align: left;
	overflow: hidden;
}

/* styles for a solid line in the legend */
.dygraph-legend-line {
	display: inline-block;
	position: relative;
	bottom: .5ex;
	padding-left: 1em;
	height: 1px;
	border-bottom-width: 2px;
	border-bottom-style: solid;
	/* border-bottom-color is set based on the series color */
}

/* styles for a dashed line in the legend, e.g. when strokePattern is set */
.dygraph-legend-dash {
	display: inline-block;
	position: relative;
	bottom: .5ex;
	height: 1px;
	border-bottom-width: 2px;
	border-bottom-style: solid;
	/* border-bottom-color is set based on the series color */
	/* margin-right is set based on the stroke pattern */
	/* padding-left is set based on the stroke pattern */
}

.dygraph-roller {
	position: absolute;
	z-index: 10;
}

/* This class is shared by all annotations, including those with icons */
.dygraph-annotation {
	position: absolute;
	z-index: 10;
	overflow: hidden;
}

/* This class only applies to annotations without icons */
/* Old class name: .dygraphDefaultAnnotation */
.dygraph-default-annotation {
	border: 1px solid black;
	background-color: white;
	text-align: center;
}

.dygraph-axis-label {
	/* position: absolute; */
	/* font-size: 14px; */
	z-index: 10;
	line-height: normal;
	overflow: hidden;
	color: black;  /* replaces old axisLabelColor option */
}

.dygraph-axis-label-x {
}

.dygraph-axis-label-y {
}

.dygraph-axis-label-y2 {
}

.dygraph-title {
	font-weight: bold;
	z-index: 10;
	text-align: center;
	/* font-size: based on titleHeight option */
}

.dygraph-xlabel {
	text-align: center;
	/* font-size: based on xLabelHeight option */
}

/* For y-axis label */
.dygraph-label-rotate-left {
	text-align: center;
	/* See http://caniuse.com/#feat=transforms2d */
	transform: rotate(90deg);
	-webkit-transform: rotate(90deg);
	-moz-transform: rotate(90deg);
	-o-transform: rotate(90deg);
	-ms-transform: rotate(90deg);
}

/* For y2-axis label */
.dygraph-label-rotate-right {
	text-align: center;
	/* See http://caniuse.com/#feat=transforms2d */
	transform: rotate(-90deg);
	-webkit-transform: rotate(-90deg);
	-moz-transform: rotate(-90deg);
	-o-transform: rotate(-90deg);
	-ms-transform: rotate(-90deg);
}
`, "",{"version":3,"sources":["webpack://./main/Dygraphs.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;CACC,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,YAAY,GAAG,mBAAmB;CAClC;;;;;EAKC;CACD,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA,0CAA0C;AAC1C;CACC,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,wBAAwB;CACxB,0BAA0B;CAC1B,yDAAyD;AAC1D;;AAEA,2EAA2E;AAC3E;CACC,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,wBAAwB;CACxB,0BAA0B;CAC1B,yDAAyD;CACzD,oDAAoD;CACpD,oDAAoD;AACrD;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA,wEAAwE;AACxE;CACC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;AACjB;;AAEA,yDAAyD;AACzD,8CAA8C;AAC9C;CACC,uBAAuB;CACvB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;CACrB,WAAW;CACX,mBAAmB;CACnB,gBAAgB;CAChB,YAAY,GAAG,uCAAuC;AACvD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,4CAA4C;AAC7C;;AAEA,qBAAqB;AACrB;CACC,kBAAkB;CAClB,8CAA8C;CAC9C,wBAAwB;CACxB,gCAAgC;CAChC,6BAA6B;CAC7B,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,8CAA8C;CAC9C,yBAAyB;CACzB,iCAAiC;CACjC,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;AAC9B","sourcesContent":["/**\n * Default styles for the dygraphs charting library.\n */\n\n.dygraph-legend {\n\tposition: absolute;\n\tfont-size: 14px;\n\tz-index: 10;\n\twidth: 250px;  /* labelsDivWidth */\n\t/*\n\tdygraphs determines these based on the presence of chart labels.\n\tIt might make more sense to create a wrapper div around the chart proper.\n\ttop: 0px;\n\tright: 2px;\n\t*/\n\tbackground: white;\n\tline-height: normal;\n\ttext-align: left;\n\toverflow: hidden;\n}\n\n/* styles for a solid line in the legend */\n.dygraph-legend-line {\n\tdisplay: inline-block;\n\tposition: relative;\n\tbottom: .5ex;\n\tpadding-left: 1em;\n\theight: 1px;\n\tborder-bottom-width: 2px;\n\tborder-bottom-style: solid;\n\t/* border-bottom-color is set based on the series color */\n}\n\n/* styles for a dashed line in the legend, e.g. when strokePattern is set */\n.dygraph-legend-dash {\n\tdisplay: inline-block;\n\tposition: relative;\n\tbottom: .5ex;\n\theight: 1px;\n\tborder-bottom-width: 2px;\n\tborder-bottom-style: solid;\n\t/* border-bottom-color is set based on the series color */\n\t/* margin-right is set based on the stroke pattern */\n\t/* padding-left is set based on the stroke pattern */\n}\n\n.dygraph-roller {\n\tposition: absolute;\n\tz-index: 10;\n}\n\n/* This class is shared by all annotations, including those with icons */\n.dygraph-annotation {\n\tposition: absolute;\n\tz-index: 10;\n\toverflow: hidden;\n}\n\n/* This class only applies to annotations without icons */\n/* Old class name: .dygraphDefaultAnnotation */\n.dygraph-default-annotation {\n\tborder: 1px solid black;\n\tbackground-color: white;\n\ttext-align: center;\n}\n\n.dygraph-axis-label {\n\t/* position: absolute; */\n\t/* font-size: 14px; */\n\tz-index: 10;\n\tline-height: normal;\n\toverflow: hidden;\n\tcolor: black;  /* replaces old axisLabelColor option */\n}\n\n.dygraph-axis-label-x {\n}\n\n.dygraph-axis-label-y {\n}\n\n.dygraph-axis-label-y2 {\n}\n\n.dygraph-title {\n\tfont-weight: bold;\n\tz-index: 10;\n\ttext-align: center;\n\t/* font-size: based on titleHeight option */\n}\n\n.dygraph-xlabel {\n\ttext-align: center;\n\t/* font-size: based on xLabelHeight option */\n}\n\n/* For y-axis label */\n.dygraph-label-rotate-left {\n\ttext-align: center;\n\t/* See http://caniuse.com/#feat=transforms2d */\n\ttransform: rotate(90deg);\n\t-webkit-transform: rotate(90deg);\n\t-moz-transform: rotate(90deg);\n\t-o-transform: rotate(90deg);\n\t-ms-transform: rotate(90deg);\n}\n\n/* For y2-axis label */\n.dygraph-label-rotate-right {\n\ttext-align: center;\n\t/* See http://caniuse.com/#feat=transforms2d */\n\ttransform: rotate(-90deg);\n\t-webkit-transform: rotate(-90deg);\n\t-moz-transform: rotate(-90deg);\n\t-o-transform: rotate(-90deg);\n\t-ms-transform: rotate(-90deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
